import React from 'react';
import { useNavigate } from 'react-router-dom';
import { convertDate } from '../../../global/utils/dateConveter';

interface BookingItemProps {
    reservationNumber: string;
    pickUpLocation: string;
    dropOffLocation: string;
    date: string;
    time: string;
    status: string;
}

const BookingItem: React.FC<BookingItemProps> = ({ reservationNumber, pickUpLocation, dropOffLocation, date, time, status }) => {
    const navigate = useNavigate();
    return (
        <div
            className="border p-4 mb-4 rounded-xl cursor-pointer hover:shadow-lg space-y-5"
            onClick={() => navigate(`/trip/${reservationNumber}`)}
        >
            <div className="flex justify-between items-center mb-2">
                <span className="font-semibold">Reservation Number: {reservationNumber}</span>
                <span
                    className={`font-semibold 
                    ${status === 'Cancelled' ? 'text-red-500'
                            : status === 'Done' ? 'text-green-500'
                                : status === 'Pending' ? 'text-yellow-500'
                                    : 'text-blue-500'}
                    `}
                >
                    {status}
                </span>
            </div>
            <div className="flex flex-col md:flex-row gap-8">
                {pickUpLocation &&
                    <div className='flex flex-col'>
                        <span className='text-[rgb(89,93,98,1)] text-sm]'>Pick - Up</span>
                        <span className='text-primaryColorDark text-sm font-bold'>{pickUpLocation}</span>
                        <div className='text-primaryColorDark flex items-center gap-2 text-sm'>
                            <span className="min-w-[135px]"> {pickUpLocation ? convertDate(date) : null}</span>
                            <span>|</span>
                            <span> {time ? time : null}</span>
                        </div>
                    </div>
                }
                {dropOffLocation &&
                    <div className='flex flex-col'>
                        <span className='text-[rgb(89,93,98,1)] text-sm]'>Drop - Off</span>
                        <span className='text-primaryColorDark text-sm font-bold'>{dropOffLocation}</span>
                        <div className='text-primaryColorDark flex items-center gap-2 text-sm'>
                            <span className="min-w-[135px]"> {pickUpLocation ? convertDate(date) : null}</span>
                            <span>|</span>
                            <span> {time ? time : null}</span>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default BookingItem;
